<template>
    <div class="business">
        <PCBusiness v-if="! isMobile"></PCBusiness>
        <MobileBusiness v-if="isMobile"></MobileBusiness>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import PCBusiness from "./business/PCBusiness";
    import MobileBusiness from "./business/MobileBusiness";
    export default {
        name: "Business",
        components: {MobileBusiness, PCBusiness},
        computed: {
            ...mapGetters(['isMobile'])
        }
    }
</script>

<style scoped>
    .business {
        height: 100%;
        width: 100%;
    }

</style>
